import { render, staticRenderFns } from "./pagehead.vue?vue&type=template&id=d8d651f4&scoped=true"
import script from "./pagehead.vue?vue&type=script&lang=js"
export * from "./pagehead.vue?vue&type=script&lang=js"
import style0 from "./pagehead.vue?vue&type=style&index=0&id=d8d651f4&prod&lang=scss&scoped=true"
import style1 from "./pagehead.vue?vue&type=style&index=1&id=d8d651f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d651f4",
  null
  
)

export default component.exports